var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBillPayment = function SvgBillPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#7D6E5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Bill_Payment_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Bill_Payment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#000",
    d: "M30-3h22v24H30z"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 11,
    cy: 36,
    r: 15,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.227,
    y: 11.364,
    width: 28.591,
    height: 33.636,
    rx: 3,
    fill: "#D1B896"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.864,
    y: 8,
    width: 28.591,
    height: 33.636,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.732 14.816h18.5M15.732 21.631h18.5",
    stroke: "#A79378",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M15.732 28.447H28.39M15.732 34.776h4.869",
    stroke: "#A79378",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgBillPayment;